/** 统一圆角胶囊关闭/返回按钮样式（与 All Activity 左上角一致：shadow + backdrop-blur） */
export const CAPSULE_BTN_CLASS =
	'h-11 w-11 rounded-full grid place-items-center bg-white/50 backdrop-blur-xl ring-1 ring-white/60 shadow-[0_18px_38px_rgba(15,23,42,0.14)] active:scale-[0.98] transition pointer-events-auto'
